import { positionDropdown } from '../dropdown'
import { MAX_POSITION_ARROW, POSITION_KEY, SIZE_BUFFER } from './constants'
import classes from './index.module.scss'

export const getPositionTopBottom = (
  contentRef,
  bodySize,
  defaultDropdownRect,
  positionKey,
) => {
  const { width: bodyWidth } = bodySize

  const {
    left: contentLeft,
    right: contentRight,
    width: contentWidth,
  } = contentRef.current?.getBoundingClientRect()

  const {
    left: defaultLeft,
    right: defaultRight,
    width: defaultWidth,
  } = defaultDropdownRect

  if (
    contentLeft > 0 &&
    defaultLeft - SIZE_BUFFER < 0 &&
    contentLeft + defaultWidth + SIZE_BUFFER < bodyWidth
  ) {
    return positionKey === POSITION_KEY.TOP
      ? positionDropdown.TOP_START_RIGHT
      : positionDropdown.BOTTOM_START_RIGHT
  } else if (
    contentRight < bodyWidth &&
    defaultRight + SIZE_BUFFER > bodyWidth &&
    contentRight - defaultWidth - SIZE_BUFFER > 0
  ) {
    return positionKey === POSITION_KEY.TOP
      ? positionDropdown.TOP_END_LEFT
      : positionDropdown.BOTTOM_END_LEFT
  } else if (
    ((defaultLeft - SIZE_BUFFER < 0 &&
      contentLeft + defaultWidth + SIZE_BUFFER > bodyWidth) ||
      (defaultRight + SIZE_BUFFER > bodyWidth &&
        contentRight - defaultWidth - SIZE_BUFFER < 0)) &&
    contentLeft - (defaultWidth - contentWidth) / 2 - SIZE_BUFFER > 0 &&
    contentLeft + (defaultWidth + contentWidth) / 2 + SIZE_BUFFER < bodyWidth
  ) {
    return positionKey === POSITION_KEY.TOP
      ? positionDropdown.TOP_CENTER
      : positionDropdown.BOTTOM_CENTER
  }
}

export const getPositionTop = (
  contentRef,
  bodySize,
  defaultDropdownRect,
  position,
  dropdownSpace,
) => {
  if (
    [
      positionDropdown.TOP_CENTER,
      positionDropdown.TOP_START_RIGHT,
      positionDropdown.TOP_END_LEFT,
    ].includes(position)
  ) {
    const { top: contentTop } = contentRef.current?.getBoundingClientRect()
    const { height: defaultHeight } = defaultDropdownRect

    if (contentTop - defaultHeight - dropdownSpace - SIZE_BUFFER < 0) {
      const priorityPosition =
        getPositionTopBottom(
          contentRef,
          bodySize,
          defaultDropdownRect,
          POSITION_KEY.BOTTOM,
        ) || position.replace(POSITION_KEY.TOP, POSITION_KEY.BOTTOM)

      return priorityPosition
    } else {
      const priorityPosition =
        getPositionTopBottom(
          contentRef,
          bodySize,
          defaultDropdownRect,
          POSITION_KEY.TOP,
        ) || position

      return priorityPosition
    }
  }
}

export const getPositionBottom = (
  contentRef,
  bodySize,
  defaultDropdownRect,
  position,
  dropdownSpace,
) => {
  if (
    [
      positionDropdown.BOTTOM_CENTER,
      positionDropdown.BOTTOM_START_RIGHT,
      positionDropdown.BOTTOM_END_LEFT,
    ].includes(position)
  ) {
    const { bottom: contentBottom } =
      contentRef.current?.getBoundingClientRect()
    const { height: defaultHeight } = defaultDropdownRect
    const { height: bodyHeight } = bodySize

    if (
      contentBottom + defaultHeight + dropdownSpace + SIZE_BUFFER >
      bodyHeight
    ) {
      const priorityPosition =
        getPositionTopBottom(
          contentRef,
          bodySize,
          defaultDropdownRect,
          POSITION_KEY.TOP,
        ) || position.replace(POSITION_KEY.BOTTOM, POSITION_KEY.TOP)

      return priorityPosition
    } else {
      const priorityPosition =
        getPositionTopBottom(
          contentRef,
          bodySize,
          defaultDropdownRect,
          POSITION_KEY.BOTTOM,
        ) || position

      return priorityPosition
    }
  }
}

export const getPositionLeft = (
  contentRef,
  bodySize,
  defaultDropdownRect,
  position,
  dropdownSpace,
) => {
  if (
    [
      positionDropdown.LEFT_CENTER,
      positionDropdown.LEFT_START,
      positionDropdown.LEFT_END,
    ].includes(position)
  ) {
    const { left: contentLeft, right: contentRight } =
      contentRef.current?.getBoundingClientRect()
    const { width: defaultWidth } = defaultDropdownRect
    const { width: bodyWidth } = bodySize

    if (
      contentLeft - defaultWidth - dropdownSpace - SIZE_BUFFER < 0 &&
      contentRight + defaultWidth + dropdownSpace + SIZE_BUFFER < bodyWidth
    ) {
      return position.replace(POSITION_KEY.LEFT, POSITION_KEY.RIGHT)
    } else {
      return position
    }
  }
}

export const getPositionRight = (
  contentRef,
  bodySize,
  defaultDropdownRect,
  position,
  dropdownSpace,
) => {
  if (
    [
      positionDropdown.RIGHT_CENTER,
      positionDropdown.RIGHT_START,
      positionDropdown.RIGHT_END,
    ].includes(position)
  ) {
    const { left: contentLeft, right: contentRight } =
      contentRef.current?.getBoundingClientRect()
    const { width: defaultWidth } = defaultDropdownRect
    const { width: bodyWidth } = bodySize

    if (
      contentLeft - defaultWidth - dropdownSpace - SIZE_BUFFER > 0 &&
      contentRight + defaultWidth + dropdownSpace + SIZE_BUFFER > bodyWidth
    ) {
      return position.replace(POSITION_KEY.RIGHT, POSITION_KEY.LEFT)
    } else {
      return position
    }
  }
}

export const getTooltipArrowClass = (priorityPosition) => {
  if (!priorityPosition || priorityPosition.includes(POSITION_KEY.TOP)) {
    return classes.tooltipArrowTop
  }
  if (priorityPosition.includes(POSITION_KEY.BOTTOM)) {
    return classes.tooltipArrowBottom
  }
  if (priorityPosition.includes(POSITION_KEY.LEFT)) {
    return classes.tooltipArrowLeft
  }
  if (priorityPosition.includes(POSITION_KEY.RIGHT)) {
    return classes.tooltipArrowRight
  }
}

export const getArrowPositionStyle = (contentRef, priorityPosition) => {
  if (!priorityPosition || !contentRef.current) return {}

  if (
    [
      positionDropdown.TOP_START_RIGHT,
      positionDropdown.BOTTOM_START_RIGHT,
    ].includes(priorityPosition)
  ) {
    const halfContentWidth =
      (contentRef.current?.getBoundingClientRect().width || 0) / 2
    return {
      left:
        halfContentWidth < MAX_POSITION_ARROW
          ? halfContentWidth
          : MAX_POSITION_ARROW,
    }
  }

  if (
    [positionDropdown.TOP_END_LEFT, positionDropdown.BOTTOM_END_LEFT].includes(
      priorityPosition,
    )
  ) {
    const halfContentWidth =
      (contentRef.current?.getBoundingClientRect().width || 0) / 2
    return {
      right:
        halfContentWidth < MAX_POSITION_ARROW
          ? halfContentWidth
          : MAX_POSITION_ARROW,
      left: 'unset',
    }
  }

  if (
    [positionDropdown.LEFT_START, positionDropdown.RIGHT_START].includes(
      priorityPosition,
    )
  ) {
    const halfContentHeight =
      (contentRef.current?.getBoundingClientRect().height || 0) / 2
    return {
      top:
        halfContentHeight < MAX_POSITION_ARROW
          ? halfContentHeight
          : MAX_POSITION_ARROW,
    }
  }

  if (
    [positionDropdown.LEFT_END, positionDropdown.RIGHT_END].includes(
      priorityPosition,
    )
  ) {
    const halfContentHeight =
      (contentRef.current?.getBoundingClientRect().height || 0) / 2
    return {
      bottom:
        halfContentHeight < MAX_POSITION_ARROW
          ? halfContentHeight
          : MAX_POSITION_ARROW,
      top: 'unset',
    }
  }
}

export const getPositionInsideContent = (contentRef, position) => {
  if (!position || !contentRef.current) return 0

  if (
    position.includes(POSITION_KEY.TOP) ||
    position.includes(POSITION_KEY.BOTTOM)
  ) {
    return -(contentRef.current?.getBoundingClientRect().height || 0) * (2 / 3)
  }

  if (
    position.includes(POSITION_KEY.LEFT) ||
    position.includes(POSITION_KEY.RIGHT)
  ) {
    return -(contentRef.current?.getBoundingClientRect().width || 0) * (2 / 3)
  }

  return 0
}
